import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { CONSTANTS } from '@livable/saas-react-components';
import { Typography, Button, Paper } from '@mui/material';
import { observer } from 'mobx-react-lite';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';
// import { useNavigate } from 'react-router-dom';
import finishLine from 'src/img/finish-line.svg';
import { ActivatedPropertyModal } from 'src/components/property/ActivatedPropertyModal';
import AccountMaintananceFee from 'src/components/unit/AccountMaintananceFee';
import { USER_SETTINGS_KEYS } from 'src/constants/userSetting';
import { BILL_FREQUENCY_NAME } from 'src/constants/utilities';
import { PROPERTY_STEPS, DEMO_PROPERTY_STEPS, APPFOLIO_PROPERTY_STEPS } from 'src/constants/property';
import { useStore } from 'src/stores';
import InfoBlock from './InfoBlock';
import useStyles from './styles';
import { FEE_CONSTANT, FEE_UNIT_TYPES } from 'src/constants/feesSetting';
const capitalizeFirstLetter = string => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};
export const PropertyConfirmPage = observer(_ref => {
  let _ref$handleStep = _ref.handleStep,
    handleStep = _ref$handleStep === void 0 ? () => {} : _ref$handleStep,
    notCompletedPropertyId = _ref.notCompletedPropertyId,
    registerActionBack = _ref.registerActionBack,
    registerActionNext = _ref.registerActionNext;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const currentPropertyId = localStorage.getItem('livable_property_id') || notCompletedPropertyId;
  const CURRENT_STEPS = store.company.companyFeatureStore.isAppfolio ? APPFOLIO_PROPERTY_STEPS : PROPERTY_STEPS;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpenModal = _useState2[0],
    setIsOpenModal = _useState2[1];
  const _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    companyTotalUnits = _useState4[0],
    setCompanyTotalUnits = _useState4[1];
  const _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    paymentMethod = _useState6[0],
    setPaymentMethod = _useState6[1];
  const confirmSteps = async () => {
    const activatePropertyAsyncResp = await store.properties.activatePropertyAsync.run({
      propertyId: currentPropertyId
    });
    if (activatePropertyAsyncResp !== null && activatePropertyAsyncResp !== void 0 && activatePropertyAsyncResp.isSuccessful) {
      setIsOpenModal(true);
      await store.properties.updatePropertySetupProgressAsync.run({
        propertyId: currentPropertyId,
        propertySetupStep: localStorage.getItem('livable_demo_mode') !== 'Demo' ? Object.keys(CURRENT_STEPS).find(key => CURRENT_STEPS[key] === CURRENT_STEPS.ConfirmProperty) : Object.keys(DEMO_PROPERTY_STEPS).find(key => DEMO_PROPERTY_STEPS[key] === DEMO_PROPERTY_STEPS.ConfirmProperty)
      });
    }
  };
  const generalInfo = {
    title: store.addNewProperty.propertyInformation.propertyAddress,
    details: [{
      title: t('add_new_property_flow.ownership_entity'),
      data: store.addNewProperty.propertyInformation.ownership
    }, {
      title: t('general.square_footage'),
      data: store.addNewProperty.propertyInformation.buildingSquare && store.addNewProperty.propertyInformation.buildingSquare !== 'null' ? "".concat(store.addNewProperty.propertyInformation.buildingSquare, " ft.") : 'N/A'
    }]
  };

  // const primaryBuildingContact =
  //   store.addNewProperty.contactInformation.selectBuildingContacts.length > 0
  //     ? store.addNewProperty.contactInformation.selectBuildingContacts
  //         .map(elem => {
  //           return `${elem.firstName} ${elem.lastName}`;
  //         })
  //         .join(', ')
  //     : `${store.account.userProfile.firstName} ${store.account.userProfile.lastName}`;

  // const contactInfo = {
  //   title: t('add_new_property_flow.contact_information'),
  //   details: [
  //     {
  //       title: t('add_new_property_flow.primary_building_contact'),
  //       data: primaryBuildingContact,
  //     },
  //     {
  //       title: t('add_new_property_flow.primary_utilities_contact'),
  //       data:
  //         store.addNewProperty.contactInformation.selectUtilitiesContacts.length > 0
  //           ? store.addNewProperty.contactInformation.selectUtilitiesContacts
  //               .map(elem => {
  //                 return `${elem.firstName} ${elem.lastName}`;
  //               })
  //               .join(', ')
  //           : primaryBuildingContact,
  //     },
  //   ],
  // };

  const getName = name => {
    var _fee$value, _fee$value2;
    const fee = store.addNewProperty.feeStructureV2.getPropertyFee({
      feeName: name
    });
    return fee && ((_fee$value = fee.value) === null || _fee$value === void 0 ? void 0 : _fee$value.toFixed(2)) > 0 ? "$".concat((_fee$value2 = fee.value) === null || _fee$value2 === void 0 ? void 0 : _fee$value2.toFixed(2)) : 'Not set';
  };
  const feeStructureInfo = {
    title: t('add_new_property_flow.fee_structure'),
    details: [{
      title: t('add_new_property_flow.amf'),
      data: getName('adminFee')
    }, {
      title: t('add_new_property_flow.late_fee'),
      data: store.addNewProperty.feeStructureV2.getPropertyFee({
        feeName: 'lateFee'
      }) !== null ? "".concat(store.addNewProperty.feeStructureV2.getPropertyFee({
        feeName: 'lateFee'
      }).feeUnitType === FEE_UNIT_TYPES.fixedAmount ? '$' : '').concat(store.addNewProperty.feeStructureV2.getPropertyFee({
        feeName: 'lateFee'
      }).value.toFixed(2), " ").concat(store.addNewProperty.feeStructureV2.getPropertyFee({
        feeName: 'lateFee'
      }).feeUnitType === FEE_UNIT_TYPES.percentage ? '%' : '') : 'Not set'
    }, {
      title: t('add_new_property_flow.nsf'),
      data: 'Coming soon...'
    }, {
      title: t('add_new_property_flow.paper_statement_fee', {
        feePrice: ''
      }),
      data: "$".concat(FEE_CONSTANT.paperStatement.toFixed(2))
      //   `${
      //   store.addNewProperty.feeStructureV2.getPropertyFee({
      //     feeName: 'paperStatementFee',
      //   }) === null
      //     ? t('add_new_property_flow.me')
      //     : t('add_new_property_flow.resident')
      // }`,
    }]
  };
  const utilitiesInfo = {
    title: t('add_new_property_flow.bill_back_utilities'),
    utilities: []
  };
  store.addNewProperty.utilitiesSetupV2.selectedUtilities.map(item => {
    utilitiesInfo.utilities.push({
      utility: item.name,
      billFrequency: capitalizeFirstLetter(BILL_FREQUENCY_NAME[item.billFrequencyType]),
      allocationMethod: capitalizeFirstLetter(CONSTANTS.ALLOCATION_METHODS[item.allocationMethod]),
      cad: item.utilityCAD
    });
  });
  const unitSetupInfo = {
    title: t('add_new_property_flow.unit_setup'),
    buildings: [{
      address: "".concat(t('general.primary'), ": ").concat(store.addNewProperty.propertyInformation.propertyAddress),
      units: store.addNewProperty.unitSetup.units.length
    }]
  };
  const appfolioUnitsInfo = {
    title: "Units: ".concat(store.addNewProperty.unitSetup.units.length)
  };
  const appfolioResidentsInfo = {
    title: "Residents: ".concat(store.addNewProperty.residentsSetup.residents.length)
  };
  const defaultPaymentMethod = store.payment.paymentMethods.find(i => i.isDefault);
  const currentPaymentMethod = store.payment.paymentMethods.find(i => i.id === paymentMethod);
  const getPaymentMethodText = pm => "Payment method: ".concat(capitalizeFirstLetter(pm.brand), " ending in \u2022\u2022\u2022\u2022 ").concat(pm.last4);
  const appfolioPaymentMethodInfo = {
    title: currentPaymentMethod && currentPaymentMethod !== null && currentPaymentMethod !== void 0 && currentPaymentMethod.brand ? getPaymentMethodText(currentPaymentMethod) : defaultPaymentMethod && defaultPaymentMethod !== null && defaultPaymentMethod !== void 0 && defaultPaymentMethod.brand ? getPaymentMethodText(defaultPaymentMethod) : 'N/A'
  };
  const fetchAsyncData = async () => {
    var _paymentMethodResp$re;
    const companyId = localStorage.getItem(USER_SETTINGS_KEYS.company) || '';
    const resp = await store.company.getCompanyUnitsAsync.run({
      companyId
    });
    if (resp && resp.isSuccessful) {
      setCompanyTotalUnits(resp.response);
    }
    const paymentMethodResp = await store.payment.getPropertyPaymentMethodAsync.run({
      applyToHomeDashboard: false,
      propertyId: currentPropertyId
    });
    if (paymentMethodResp && paymentMethodResp !== null && paymentMethodResp !== void 0 && paymentMethodResp.isSuccessful) setPaymentMethod(paymentMethodResp === null || paymentMethodResp === void 0 || (_paymentMethodResp$re = paymentMethodResp.response) === null || _paymentMethodResp$re === void 0 ? void 0 : _paymentMethodResp$re.paymentMethodId);
  };
  useEffect(() => {
    fetchAsyncData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (registerActionBack !== undefined) registerActionBack(() => {
      handleStep(store.company.companyFeatureStore.isAppfolio ? APPFOLIO_PROPERTY_STEPS.PayoutDetails : localStorage.getItem('livable_demo_mode') !== 'Demo' ? CURRENT_STEPS.UnitSetup : DEMO_PROPERTY_STEPS.UnitSetup)();
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [registerActionBack]);
  useEffect(() => {
    if (registerActionNext !== undefined) registerActionNext(() => {
      confirmSteps();
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [registerActionNext]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, !store.company.companyFeatureStore.isAppfolio && /*#__PURE__*/React.createElement(Paper, null, /*#__PURE__*/React.createElement("div", {
    className: classes.backgroundContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.content
  }, /*#__PURE__*/React.createElement("img", {
    src: finishLine,
    width: "240",
    height: "180",
    alt: "finish line illustation"
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.congratulationText
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h2"
  }, t('add_new_property_flow.congratulations')), /*#__PURE__*/React.createElement("div", {
    className: classes.xsSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    color: "light"
  }, t('add_new_property_flow.congratulations_hint'))))))), store.company.companyFeatureStore.isAppfolio && /*#__PURE__*/React.createElement(Paper, null, /*#__PURE__*/React.createElement("div", {
    className: classes.appfolioBackgroundContainer
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h2"
  }, t('add_new_property_flow.congratulations')), /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    color: "light"
  }, t('add_new_property_flow.congratulations_hint')))), /*#__PURE__*/React.createElement(InfoBlock, {
    info: generalInfo,
    stepIndex: CURRENT_STEPS.PropertyInformation,
    handleEdit: handleStep
  }), !store.company.companyFeatureStore.isAppfolio && /*#__PURE__*/React.createElement(InfoBlock, {
    info: feeStructureInfo,
    stepIndex: localStorage.getItem('livable_demo_mode') !== 'Demo' ? CURRENT_STEPS.FeeSetup : DEMO_PROPERTY_STEPS.FeeSetup,
    handleEdit: handleStep
  }), localStorage.getItem('livable_demo_mode') !== 'Demo' && !store.company.companyFeatureStore.isAppfolio && /*#__PURE__*/React.createElement(Paper, null, /*#__PURE__*/React.createElement(AccountMaintananceFee, {
    enrolled: Number(companyTotalUnits) + Number(store.addNewProperty.unitSetup.units.length),
    subscriptionName: store.payment.subscriptionName,
    propertyConfigMode: true
  })), /*#__PURE__*/React.createElement(InfoBlock, {
    info: utilitiesInfo,
    stepIndex: localStorage.getItem('livable_demo_mode') !== 'Demo' ? CURRENT_STEPS.UtilityConfiguration : DEMO_PROPERTY_STEPS.UtilityConfiguration,
    handleEdit: handleStep
  }), !store.company.companyFeatureStore.isAppfolio && /*#__PURE__*/React.createElement(InfoBlock, {
    info: unitSetupInfo,
    stepIndex: localStorage.getItem('livable_demo_mode') !== 'Demo' ? CURRENT_STEPS.UnitSetup : DEMO_PROPERTY_STEPS.UnitSetup,
    handleEdit: handleStep
  }), store.company.companyFeatureStore.isAppfolio && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InfoBlock, {
    info: appfolioUnitsInfo,
    stepIndex: CURRENT_STEPS.UnitSetup,
    handleEdit: handleStep
  }), /*#__PURE__*/React.createElement(InfoBlock, {
    info: appfolioResidentsInfo,
    stepIndex: CURRENT_STEPS.FeeSetup,
    handleEdit: handleStep
  }), /*#__PURE__*/React.createElement(InfoBlock, {
    info: appfolioPaymentMethodInfo,
    stepIndex: CURRENT_STEPS.PayoutDetails,
    handleEdit: handleStep
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.pageFooter
  }, registerActionBack === undefined && registerActionNext === undefined && /*#__PURE__*/React.createElement(Button, {
    onClick: handleStep(store.company.companyFeatureStore.isAppfolio ? APPFOLIO_PROPERTY_STEPS.PayoutDetails : localStorage.getItem('livable_demo_mode') !== 'Demo' ? CURRENT_STEPS.UnitSetup : DEMO_PROPERTY_STEPS.UnitSetup),
    variant: "text",
    disabled: store.properties.activatePropertyAsync.inProgress,
    'custom-attribute': '767-property-confirm-page'
  }, t('general.back'), !store.company.companyFeatureStore.isAppfolio && /*#__PURE__*/React.createElement(React.Fragment, null, ': ', t('add_new_property_flow.unit_setup'))), !isOpenModal && registerActionBack === undefined && registerActionNext === undefined && /*#__PURE__*/React.createElement(Button, {
    onClick: confirmSteps,
    variant: "priority",
    disabled: store.properties.activatePropertyAsync.inProgress,
    'custom-attribute': '768-property-confirm-page'
  }, t('add_new_property_flow.activate_my_property')), isOpenModal && /*#__PURE__*/React.createElement(Button, {
    variant: "priority",
    component: RouterLink,
    to: "/active_dashboard",
    'custom-attribute': '769-property-confirm-page'
  }, t('add_new_property_flow.open_home_dashboard')), /*#__PURE__*/React.createElement(ActivatedPropertyModal, {
    propertyId: localStorage.getItem('livable_property_id') || notCompletedPropertyId,
    isOpen: isOpenModal,
    trigger: null,
    isNewBillingEmbedded: !(registerActionBack === undefined && registerActionNext === undefined)
  })));
});
PropertyConfirmPage.propTypes = {
  handleStep: PropTypes.func
};